import { TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";

const OTPMultiEntryComponent = (
  { otpHint = "0000", cbSubmit, cbClear },
  props
) => {
  const clear = (elem) => {};

  if (cbClear) {
    cbClear(clear);
  }

  let inputRefs = Array(6).fill(null);

  const keyUpFn = (id, inputRefs) => (e) => {
    const prev = id > 0 ? inputRefs[id - 1] : null;
    const next = id < inputRefs.length - 1 ? inputRefs[id + 1] : null;
    if (e.keyCode === 8 || e.keyCode === 37) {
      if (prev) {
        prev.select();
      }
    } else if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 65 && e.keyCode <= 90) ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      e.keyCode === 39
    ) {
      if (next) {
        next.select();
      } else {
        if (cbSubmit) {
          cbSubmit(inputRefs.reduce((acc, elem) => acc + elem.value, ""));
        }
      }
    }
  };
  return (
    <Grid container>
      <Grid item>
        {otpHint.split("").map((elem, idx) => (
          <TextField
            key={"otpHint-" + idx}
            aria-label={"OTP Prefix " + (idx + 1) + " of 4"}
            disabled
            id={"otpHint-" + idx}
            onChange={(event) => console.log(event)}
            inputProps={{
              maxLength: 1,
              style: { textAlign: "center" },
            }}
            autoComplete="one-time-pin"
            style={{ width: "2.3rem", padding: "0.2rem" }}
            value={elem}
          />
        ))}
      </Grid>
      <Grid item>
        <span
          className="splitter"
          style={{
            width: "1rem",
            padding: "0.3rem",
            fontSize: "2rem",
            textAlign: "center",
          }}
        >
          &ndash;
        </span>
      </Grid>
      <Grid item>
        {Array(6)
          .fill(null)
          .map((elem, idx) =>
            idx === 0 ? (
              <TextField
                key={"otpEntry-" + idx}
                required
                id={"otpEntry-" + idx}
                onChange={(event) => console.log(event)}
                inputProps={{
                  maxLength: 1,
                  ref: (input) => {
                    inputRefs[idx] = input;
                  },
                  style: { textAlign: "center" },
                  inputMode: "numeric",
                }}
                aria-label="OTP Entry 1 of 6"
                autoComplete="one-time-pin"
                style={{ width: "2.3rem", padding: "0.2rem" }}
                onKeyUp={keyUpFn(idx, inputRefs)}
                autoFocus
              />
            ) : (
              <TextField
                key={"otpEntry-" + idx}
                required
                id={"otpEntry-" + idx}
                aria-label={"OTP Entry " + (idx + 1) + " of 6"}
                onChange={(event) => console.log(event)}
                inputProps={{
                  maxLength: 1,
                  ref: (input) => {
                    inputRefs[idx] = input;
                  },
                  style: { textAlign: "center" },
                  inputMode: "numeric",
                }}
                autoComplete="one-time-pin"
                style={{ width: "2.3rem", padding: "0.2rem" }}
                onKeyUp={keyUpFn(idx, inputRefs)}
              />
            )
          )}
      </Grid>
    </Grid>
  );
};

export default OTPMultiEntryComponent;
